import { render, staticRenderFns } from "./regist-dialog.vue?vue&type=template&id=2c14358e&scoped=true&"
import script from "./regist-dialog.vue?vue&type=script&lang=js&"
export * from "./regist-dialog.vue?vue&type=script&lang=js&"
import style0 from "./regist-dialog.vue?vue&type=style&index=0&id=2c14358e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c14358e",
  null
  
)

export default component.exports